import { render } from "./PointPlan.vue?vue&type=template&id=50695b9d&scoped=true"
import script from "./PointPlan.vue?vue&type=script&lang=js"
export * from "./PointPlan.vue?vue&type=script&lang=js"

import "./PointPlan.vue?vue&type=style&index=0&id=50695b9d&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50695b9d"]])

export default __exports__